import isBrowser from "../../utils/isBrowser";

const noDeleteActions = ["networkStatusChange", "getExternalParameter", "externalParameter"];
let actionCallbacks = [];

export function addEventListener(name, callback) {
  let callbacks;
  if (!(callbacks = actionCallbacks[name])) {
    callbacks = actionCallbacks[name] = [];
  } else {
    removeEventListener(name, callback);
  }
  callbacks.push(callback);
}

function removeEventListener(name, callback) {
  const callbacks = actionCallbacks[name];
  if (callbacks) {
    for (let i = 0, l = callbacks.length; i < l; i++) {
      if (callbacks[i] === callback) {
        callbacks.splice(i, 1);
        return;
      }
    }
  }
}

export function nativeCallback(data) {
  const callbacks = actionCallbacks[data.command];
  if (callbacks && callbacks.length > 0) {
    switch (data.command) {
      // thoses events are not removed from the callback list
      case "psnEntitlementList":
      case "networkStatusChange":
      case "getExternalParameter":
      case "playerError":
      case "externalParameter":
      case "getPlaybackTime":
      case "playerStreamingError":
      case "applicationStatusChange":
      case "contentAvailable":
      case "playerStatusChange":
        // multiple event listeners may be listening for these events
        for (var i = 0; i < callbacks.length; i++) {
          callbacks[i](data);
        }
        break;
      default:
        // function return (pick the earliest callback handler)
        const callback = callbacks.shift(1);
        callback(data);
        break;
    }
  }
}

export function webmafAction(command, data, callback) {
  typeof callback === "function" && addEventListener(command, callback, true);
  isBrowser && window.external.user(JSON.stringify({ command, ...data }));
}

export function resetCallbacks() {
  Object.keys(actionCallbacks).forEach(action => !noDeleteActions.includes(action) && delete actionCallbacks[action]);
}

export const wefmafActionResponseStates = {
  ok: "ok",
  fail: "fail"
};
